import React from 'react';
import { FieldLabel, FieldMessage, useFieldSemantics } from './fieldSemantics';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, helperText, className = '', id, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, children, ...props }, ref) => {
    const field = useFieldSemantics({
      id,
      error,
      helperText,
      'aria-describedby': ariaDescribedBy,
      'aria-invalid': ariaInvalid,
    });
    const selectId = field.fieldId;

    return (
      <div className="w-full">
        {label && <FieldLabel htmlFor={selectId}>{label}</FieldLabel>}
        <select
          ref={ref}
          id={selectId}
          className={`
            block w-full px-3 py-2 border rounded-md bg-slate-900 text-white
            focus:border-brand-500 focus:ring-1 focus:ring-brand-500
            focus-visible:outline-2 focus-visible:outline-offset-2
            disabled:bg-slate-800/50 disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500 focus-visible:outline-red-500' : 'border-slate-700 focus-visible:outline-brand-500'}
            ${className}
          `}
          {...props}
          {...field.controlProps}
        >
          {children}
        </select>
        <FieldMessage field={field} />
      </div>
    );
  }
);

Select.displayName = 'Select';
